import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "txt-center": "" }
const _hoisted_2 = {
  key: 0,
  "m-rl-auto": "",
  style: {"max-width":"350px"},
  "txt-center": ""
}
const _hoisted_3 = {
  key: 1,
  "m-rl-auto": "",
  style: {"max-width":"350px"},
  "txt-center": ""
}
const _hoisted_4 = { "txt-center": "" }
const _hoisted_5 = { style: {"padding-right":"6px"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_BusinessCofounderModal = _resolveComponent("BusinessCofounderModal")!
  const _component_CircleCheckFilled = _resolveComponent("CircleCheckFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "custom-class": "App-Create-Business-Modal App-Unpadded",
      "model-value": _ctx.isModalOpen,
      width: "550px",
      "show-close": _ctx.showClose,
      "close-on-click-modal": _ctx.showClose,
      "close-on-press-escape": _ctx.showClose,
      onOpen: _ctx.opened,
      title: "Co-founder Profiles",
      center: "",
      "append-to-body": true,
      "lock-scroll": true,
      "open-delay": 200,
      "before-close": _ctx.closeModal,
      "close-delay": 200
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_button, {
            "is-block": "",
            icon: "el-icon-check",
            onClick: _ctx.exit,
            size: "large",
            type: "primary",
            disabled: _ctx.someInfoIsMissing() || _ctx.loading
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Continue ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
          always: true,
          "max-height": "70vh"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_el_image, {
                      style: `width: 250px;`,
                      src: _ctx.img
                    }, null, 8, ["src"]),
                    (_ctx.business.coFoundersSize > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                          _createTextVNode(" Provide your co-founders ", -1),
                          _createElementVNode("br", null, null, -1),
                          _createTextVNode(" education and skills information ", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_3, [...(_cache[1] || (_cache[1] = [
                          _createTextVNode(" You don't need to fill this. ", -1),
                          _createElementVNode("br", null, null, -1),
                          _createTextVNode(" You have indicated that you don't have co-founders. ", -1)
                        ]))]))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_space, {
                  fill: "",
                  "w-100": "",
                  alignment: "center",
                  direction: "vertical"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coFounders, (coFounder, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `cofounder-${index}`
                      }, [
                        (_ctx.modals[index] === true)
                          ? (_openBlock(), _createBlock(_component_BusinessCofounderModal, {
                              key: 0,
                              isModalOpen: _ctx.modals[index] === true,
                              onClosed: ($event: any) => (_ctx.modals[index] = false),
                              business: _ctx.business,
                              coFounder: _ctx.coFounders[index],
                              coFounderIndex: index
                            }, null, 8, ["isModalOpen", "onClosed", "business", "coFounder", "coFounderIndex"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_space, {
                          wrap: false,
                          direction: "horizontal"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_tag, {
                              style: _normalizeStyle({
                      minWidth:
                        index != 0 && index != _ctx.coFounders.length - 1
                          ? '250px'
                          : '100px',
                    }),
                              type: "info",
                              round: ""
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_5, [
                                  (_ctx.isCoFounderFilled(index))
                                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_CircleCheckFilled, { success: "" })
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_WarningFilled, { danger: "" })
                                        ]),
                                        _: 1
                                      }))
                                ]),
                                coFounder
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$filters.capitalize(
                          coFounder.names ||
                            `Provide Names (Co-founder ${index + 1})`
                        )), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_7, " Provide Names (Co-founder " + _toDisplayString(index + 1) + ")", 1))
                              ]),
                              _: 2
                            }, 1032, ["style"]),
                            _createVNode(_component_el_button, {
                              onClick: ($event: any) => (_ctx.editCofounder(index)),
                              icon: "el-icon-edit",
                              circle: "",
                              size: "mini"
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["model-value", "show-close", "close-on-click-modal", "close-on-press-escape", "onOpen", "before-close"])
  ]))
}